import { useQuery } from '@tanstack/react-query'
import { ClientsService } from '@/services/clients'
import { ReservationsService } from '@/services/reservations'
import { ViatgersService } from '@/services/viatgers'

export interface DashboardStats {
    totalReserves: number
    checkinsToday: number
    checkoutsToday: number
    totalClients: number
    totalViatgers: number
    monthlyRevenue: number
    occupancyRate: number
}

export function useDashboardStats() {
    return useQuery({
        queryKey: ['dashboard-stats'],
        queryFn: async (): Promise<DashboardStats> => {
            // Parallel requests for better performance
            const [clientsRes, reservesRes, viatgersRes] = await Promise.all([
                ClientsService.getAll({ per_page: 1 }),
                ReservationsService.getAll({ per_page: 1 }),
                ViatgersService.getAll({ per_page: 1 })
            ])

            // For now, set checkins/checkouts to 0 since we don't have a specific endpoint for today's checkins/checkouts
            // TODO: Create specific backend endpoints for this
            const checkinsToday = 0
            const checkoutsToday = 0

            // Calculate monthly revenue (mock for now - would need backend endpoint)
            const monthlyRevenue = 0

            return {
                totalReserves: reservesRes.meta?.total || 0,
                checkinsToday,
                checkoutsToday,
                totalClients: clientsRes.meta?.total || 0,
                totalViatgers: viatgersRes.meta?.total || 0,
                monthlyRevenue,
                occupancyRate: 0 // Would need backend calculation
            }
        },
        staleTime: 1000 * 60 * 5, // 5 minutes
    })
}
